import { TC_INSTITUTIONAL_HOST, TC_PLATFORM_HOST } from '../utils/settings';

export const getBaseUrl = () => TC_PLATFORM_HOST;

export const getBaseUrlLP = () => TC_INSTITUTIONAL_HOST;
